var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.login}},[_vm._v("授权登录")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }